// extracted by mini-css-extract-plugin
export default {"tableContainer":"CouponsTable_tableContainer__GkXbx","tableTitle":"CouponsTable_tableTitle__9F-UC","tableRow":"CouponsTable_tableRow__lPtAm"};